import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ShoppingCartIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M8.405 21q-.743 0-1.272-.529a1.73 1.73 0 0 1-.53-1.271q0-.743.53-1.271a1.74 1.74 0 0 1 1.272-.529q.743 0 1.272.529.53.528.53 1.271t-.53 1.271A1.74 1.74 0 0 1 8.405 21m9.008 0q-.743 0-1.272-.529a1.73 1.73 0 0 1-.53-1.271q0-.743.53-1.271a1.74 1.74 0 0 1 1.272-.529q.744 0 1.273.529.53.528.529 1.271 0 .743-.53 1.271a1.74 1.74 0 0 1-1.272.529M7.64 6.6l2.162 4.5h6.306l2.477-4.5zm-.856-1.8h13.288q.518 0 .788.461.27.462.022.934l-3.197 5.76q-.248.45-.665.697a1.75 1.75 0 0 1-.912.248H9.396l-.991 1.8h10.81v1.8H8.405q-1.014 0-1.531-.889-.518-.888-.045-1.766l1.216-2.205L4.802 4.8H3V3h2.928z"
    />
  </BaseIcon>
)
